import React, {FC, useEffect, useMemo, useState} from "react";
import {transactionService} from "../../../store/actions";
import {Link, useParams} from "react-router-dom";
import BTable from "../../../components/b-table";
import useCommon from "../../../common/hooks/useCommon";
import {getCurrencyValue,} from "../../../common/utils/function";
import AddressName from "../../common/address-name";
import {useTranslation} from "react-i18next";
import TokenImage from "../../common/token-image";
import {useSelector} from "react-redux";

interface TransactionTokenTransfersProps {
}

interface TransactionTokenTransfersData {
}

const TransactionTokenTransfers: FC<TransactionTokenTransfersProps> = (
    props
) => {
    const {hash} = useParams();
    const {getXDC, get0x} = useCommon();
    const {t, i18n} = useTranslation();

    const _tokenType = useSelector((e: Object) => (e as any)?.common?.tokenType);
    //   const [transactionList, setTransactionList] = useState<TransactionTokenTransfersData[]>([]);
    const [loading, setLoading] = useState(true);
    const [pageIndex, setPageIndex] = useState<any>(0);
    const [transactionList, setTransactionList] =
        useState<TransactionTokenTransfersData>([]); //overview, events

    const getTransaction = async () => {
        try {
            setLoading(true);
            transactionService
                .getTransactionTokenTransfer(hash)
                .then((response) => {
                    setTransactionList(response?.items);
                    setLoading(false);
                })
                .catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getTransaction();
    }, []);
    const header = useMemo(() => {
        return [
            {
                title: `${t("Token")}`,
                param: "token",
                render: (data: any) =>
                    !!data?.token && <React.Fragment>
                        <p className="text-truncate">
                            <Link to={`/token/${data?.token?.address}`} className="d-flex align-items-center">
                                <TokenImage image={data?.token?.icon_url} symbol={data?.token?.symbol} params={{width: 20, className: "me-1"}}/>
                                {data?.token?.name} ({data?.token?.symbol})
                            </Link>
                        </p>
                        <p className="bs-tab-item d-inline">
                            {data?.token?.type === "ERC-20" ? `${_tokenType}-20` :
                                data?.token?.type === "ERC-404" ? `${_tokenType}-404` :
                                    data?.token?.type === "ERC-721" ? `${_tokenType}-721` :
                                        `${_tokenType}-1155`}
                        </p>
                        <br/>
                        <p className="bs-tab-item d-inline token-type">{data?.type}</p>
                    </React.Fragment>,
            },
            {
                title: `${t("Token ID")}`,
                param: "tokenId",
                render: (data: any) => <p>{data?.total?.token_id}</p>,
            },
            {
                title: `${t("From")}`,
                param: "quantity",
                headerStyle: {minWidth: "130px"},
                copy: (data: any) => getXDC(data?.from?.hash),
                tooltip: (data: any) => <Link to={`/address/${get0x(data?.from?.hash)}`}>{getXDC(data?.from?.hash)}</Link>,
                render: (data: any) => <Link to={`/address/${get0x(data?.from?.hash)}`}><AddressName data={data?.from}/></Link>,
            },
            {
                title: `${t("To")}`,
                param: "quantity",
                headerStyle: {minWidth: "130px"},
                copy: (data: any) => getXDC(data?.to?.hash),
                tooltip: (data: any) => <Link to={`/address/${get0x(data?.to?.hash)}`}>{getXDC(data?.to?.hash)}</Link>,
                render: (data: any) => <Link to={`/address/${get0x(data?.to?.hash)}`}><AddressName data={data?.to}/></Link>,
            },
            {
                title: `${t("Value")}`,
                param: "value",
                headerStyle: {minWidth: "130px"},
                render: (data: any) => {
                    const {usd, valueStr} =
                        "value" in data?.total
                            ? getCurrencyValue({
                                value: data?.total.value,
                                exchangeRate: data?.token.fiat_value,
                                accuracy: 8,
                                accuracyUsd: 2,
                                decimals: data?.total.decimals || "0",
                            }) : {usd: null, valueStr: null};
                    return (
                        <React.Fragment>
                            <p>{valueStr}</p>
                            <p>{usd && <span className="bs-font-secondary"> ${usd}</span>}</p>
                        </React.Fragment>
                    );
                },
            },
        ];
    }, []);
    return (
        <BTable
            title={t("Transactions")}
            header={header}
            list={transactionList}
            loading={loading}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
        />
    );
};

export default TransactionTokenTransfers;
